import brandConfig, { constants } from '@ourbranch/brand-config';

import brandLogo from 'staff-brand-icons/logo.svg';
import brandOpaqueBackgroundLogo from 'staff-brand-icons/opaque-background-logo.svg';
import appConfig from 'staff-app-config';

const isBranchEnv = import.meta.env.VITE_BRAND_NAME?.toLowerCase() === 'branch';

// The build-time brand, lowercased to match the carrier keys used in @ourbranch/lookups
// (e.g. 'branch', 'cfm'). Single source of truth for injecting the brand into brand-aware
// lookup resolution — components must never hardcode a brand literal.
const brandName = import.meta.env.VITE_BRAND_NAME?.toLowerCase();

export {
  brandConfig,
  constants as brandConstants,
  brandLogo,
  brandOpaqueBackgroundLogo,
  isBranchEnv,
  brandName,
  appConfig
};
